import { useSSRData, usePlatform } from 'hooks';
import { getTranscriber } from 'utils';
import getFirstCorrectData from './utils';

export default function useTranscriber(domain, keys = []) {
    const state = useSSRData();
    const platform = usePlatform().toUpperCase();
    const transcriber = getFirstCorrectData(
        state?.transcriber,
        getTranscriber(),
        { [platform]: {} },
    );

    return keys.reduce(
        (tranlations, key) => ({
            ...tranlations,
            [key]: transcriber[platform]?.[domain]?.[key],
        }),
        {},
    );
}
